<template>
  <div class="wrapper">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <section class="section01">
            <div class="object01">
              {{ $t('ma002.title') }}
            </div>
            <div class="object02" @click="select_pw_reset">
              {{ $t('ma002.resetPassword') }}
            </div>
          </section>
          <section class="section02">
            <div class="object01"></div>
            <div class="object02">
              {{ $t('ma002.id') }}
            </div>
            <div class="object03">
              {{user_id}}
            </div>
            <div class="object04"></div>
            <div class="object05">
              {{ $t('ma002.name') }}
            </div>
            <div class="object06">
              {{user_name}}
            </div>
            <div class="object07"></div>
            <div class="object08">
              {{ $t('ma002.phone') }}
            </div>
            <div class="object09">
              {{user_phone}}
            </div>
            <div class="object10"></div>
            <div class="object11">
              {{ $t('ma002.email') }}
            </div>
            <div class="object12">
              {{user_email}}
            </div>
            <div class="object13"></div>
            <div class="object14">
              {{ $t('ma002.status') }}
            </div>
            <div class="object15">
              {{findStatusName(status)}}
            </div>
          </section>
          <section class="section03">
            <div class="object01"></div>
            <div class="object02">
              {{ $t('ma002.role') }}
            </div>
            <div class="object03">
              {{findRoleName(user_role)}}
            </div>
            <div class="object04"></div>
            <div class="object05">
              {{ $t('ma002.assignedGolfClub') }}
            </div>
            <div class="object06">
              <div class="">
                {{ managingClubNames }}
              </div>
            </div>
          </section>
          <section class="section04">
            <div class="object01"></div>
            <div class="object02">
              {{ $t('ma002.notificationSettings') }}
            </div>
            <div class="object03">
              {{ $t('ma002.notification') }}
            </div>
            <div class="object04">
              {{ $t('ma002.optOut') }}
            </div>
            <div class="object05">
              05:32 AM 2020/03/19
            </div>
            <div class="object06">
              {{ $t('ma002.sms') }}
            </div>
            <div class="object07">
              {{ $t('ma002.optIn') }}
            </div>
            <div class="object08">
              05:32 AM 2020/03/19
            </div>
            <div class="object09">
              {{ $t('ma002.email') }}
            </div>
            <div class="object10">
              {{ $t('ma002.optIn') }}
            </div>
            <div class="object11">
              05:32 AM 2020/03/19
            </div>
          </section>
          <section class="section05">
            <div class="object01" @click="moveMenu('/MA001')">
              {{ $t('common.list') }}
            </div>
            <div class="object02">
              {{ $t('ma002.lastUpdated') }} {{(updt_dt===undefined) ? '' :(updt_dt==null) ? '' : (updt_dt=='') ? '' : updt_dt.substring(0,10) + ' ' + updt_dt.substring(11,19)}} ({{user_name}} {{user_id}})
            </div>
            <div class="object03" @click="moveMenu('/MA004?account_id=' + accountUserInfo.accountInfo.account_id)">
              {{ $t('ma002.editButton') }}
            </div>
          </section>
        </div>
      </main>
      <footerLayout></footerLayout>
      <div class="alert typeConfirm">
        <div class="container">
          <div class="outer">
            <div class="inner">
              <div class="box">
                <div class="zone">
                  <div class="body" v-html="alertBodyHTML">
                  </div>
                  <div class="footer">
                    <button class="cancel">
                      {{ $t('common.cancel') }}
                    </button>
                    <button class="confirm" @click="closeAlert">
                      {{ $t('common.confirm') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="passwordPopup">
        <div class="container">
          <div class="outer">
            <div class="inner">
              <div class="box">
                <div class="zone">
                  <section class="popupSection01">
                    <div class="popupObject01"></div>
                    <div class="popupObject02">
                      {{ $t('ma002.resetPassword') }}
                    </div>
                    <div class="popupObject03" @click="pw_reset_close"></div>
                  </section>
                  <section class="popupSection02">
                    <div class="popupObject01">
                      {{ $t('ma002.id') }}
                    </div>
                    <div class="popupObject02">
                      <input type="text" v-model="user_id" disabled />
                    </div>
                    <div class="popupObject03">
                      {{ $t('ma002.name') }}
                    </div>
                    <div class="popupObject04">
                      <input type="text" v-model="user_name" disabled />
                    </div>
                    <div class="popupObject05"></div>
                    <div class="popupObject06">
                      {{ $t('ma002.newPassword') }}
                    </div>
                    <div class="popupObject07">
                      <input type="text" v-model="user_pw1" />
                    </div>
                    <div class="popupObject08">
                    </div>
                    <div class="popupObject09">
                      {{ $t('ma002.confirmNewPassword') }}
                    </div>
                    <div class="popupObject10">
                      <input type="text" v-model="user_pw2" />
                    </div>
                  </section>
                  <div class="footer">
                    <button class="cancel" @click="pw_reset_close">
                      {{ $t('common.cancel') }}
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="confirm" :disabled="(user_pw1!==user_pw2)||(user_pw1===''&&user_pw1==='')" @click="setDataPW(account_id, status, user_id, user_pw1, user_name, user_phone, user_email, user_role, ccode)">
                      {{ $t('ma002.resetPassword') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { aplManagerService, clubInfoService } from '../router'
import FooterLayout from './layout/Footer.vue'
import HeaderLayout from './layout/Header.vue'
import LeftLayout from './layout/Left.vue'

export default {
  name: 'MA002',
  data () {
    return {
      clubInfoList: [],
      userRoleList: [
        {
          roleCode: 'ClubManager',
          roleName: this.$t('ma002.roleClubManager')
        },
        {
          roleCode: 'AplMaster',
          roleName: this.$t('ma002.roleAplMaster')
        },
        {
          roleCode: 'AplManager',
          roleName: this.$t('ma002.roleAplManager')
        },
        {
          roleCode: 'AplDeveloper',
          roleName: this.$t('ma002.roleAplDeveloper')
        },
        {
          roleCode: 'SktDeveloper',
          roleName: this.$t('ma002.roleSktDeveloper')
        }
      ],
      user_pw1: '',
      user_pw2: '',
      account_id: 1,
      status: '',
      user_id: '',
      user_name: '',
      user_role: '',
      user_phone: '',
      user_email: '',
      updt_dt: '',
      ccode: '',
      ccodes: [],
      statusCodeList: [
        {
          statusCode: 'ACTIVE',
          statusName: this.$t('ma002.statusActive')
        },
        {
          statusCode: 'PASSIVE',
          statusName: this.$t('ma002.statusInactive')
        }
      ],
      accountUserInfo: {
        statusCode: null,
        data: {
          accountInfo: {
            account_id: 1,
            status: '',
            user_id: '',
            user_name: '',
            user_role: '',
            user_phone: '',
            user_email: '',
            ccode: '',
            isrt_id: '',
            isrt_dt: '',
            updt_id: '',
            updt_dt: ''
          }
        }
      },
      alertBodyHTML: '',
      callback: null
    }
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },
  created: function () {
    clubInfoService.getClubInfoList().then(response => {
      this.clubInfoList = response.data.clubInfoList
    })
  },
  mounted: function () {
    aplManagerService.getManagementUserClubName().then(response => {
      this.clubInfoList = response.data.clubInfoList
    }).catch(error => {
      console.log('aplManagerService.getManagementUserClubName.err.===>', error)
    })
    let accountId = this.$route.query.account_id
    this.setData(accountId)
    // 랜덤 비밀번호 입력
    this.user_pw1 = this.user_pw2 = this.randomPassword()
  },

  computed: {
    managingClubNames() {
      return this.ccodes.map((code) => this.findClubName(code)).join(', ')
    }
  },

  methods: {
    findStatusName: function (status) {
      if (this.statusCodeList.find(it => it.statusCode === status) !== undefined) {
        return this.statusCodeList.find(it => it.statusCode === status).statusName
      } else {
        return ''
      }
    },
    pw_reset_close: function () {
      document.querySelector('body.type-content').classList.remove('passwordPopupActive')
    },
    setDataPW: function (accountId, status, userId, userPw, userName, userPhone, userEmail, userRole, ccode) {
      aplManagerService.putManagementUserPW(accountId, status, userId, userPw, userName, userPhone, userEmail, userRole, ccode).then(response => {
        console.log('result of MA011:' + this.accountUserInfo.accountInfo.ccode)
        this.openAlert(this.$t('ma002.passwordResetDone'))
        document.querySelector('body.type-content').classList.remove('passwordPopupActive')
      }).catch(error => {
        console.log('getManagementUserInfo.err.===>', error)
      })
    },
    select_pw_reset: function () {
      document.querySelector('body.type-content').classList.add('passwordPopupActive')
    },
    findRoleName: function (userRole) {
      if (this.userRoleList.find(it => it.roleCode === userRole) !== undefined) {
        return this.userRoleList.find(it => it.roleCode === userRole).roleName
      } else {
        return ''
      }
    },
    findClubName: function (ccode) {
      if (this.clubInfoList.find(it => it.ccode === ccode) !== undefined) {
        return this.clubInfoList.find(it => it.ccode === ccode).club_name
      } else {
        return ''
      }
    },
    setData: function (accountId) {
      aplManagerService.getManagementUserInfo(accountId).then(response => {
        this.accountUserInfo = response.data
        console.log('result of MA002:' + this.accountUserInfo.accountInfo.ccode)
        this.account_id = this.accountUserInfo.accountInfo.account_id
        this.user_id = this.accountUserInfo.accountInfo.user_id
        this.status = this.accountUserInfo.accountInfo.status
        this.user_name = this.accountUserInfo.accountInfo.user_name
        this.user_role = this.accountUserInfo.accountInfo.user_role
        this.user_phone = this.accountUserInfo.accountInfo.user_phone
        this.user_email = this.accountUserInfo.accountInfo.user_email
        this.ccode = this.accountUserInfo.accountInfo.ccode
        this.updt_dt = this.accountUserInfo.accountInfo.updt_dt
        this.ccodes = this.accountUserInfo.ccodes
      }).catch(error => {
        console.log('getManagementUserInfo.err.===>', error)
      })
    },
    openAlert: function (html, cb = null) {
      this.alertBodyHTML = html
      this.callback = cb
      document.querySelector('body.type-content').classList.add('alertActive')
    },
    closeAlert: function () {
      this.alertBodyHTML = ''
      document.querySelector('body.type-content').classList.remove('alertActive')
      if (this.callback === null) return
      this.callback()
      this.callback = null
    },
    randomPassword: function () {
      let pw = ''
      let alphabet = 'abcdefghijklmnopqrstuvwxyz'
      let randomNumber = String(Math.random()).substr(2, 6)
      for (let i = 0; i < 2; i++) {
        pw += alphabet.charAt(Math.floor(Math.random() * alphabet.length))
      }
      pw += randomNumber
      return pw
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/MA002.vue